import React from 'react'
import { useTranslation } from 'react-i18next'
import { Label  } from 'reactstrap'
import Select from '../common/Select/Select'

export const SelectHorosaisonnier = ({ options = [], value, onChange, ...props }) => {
    const { t } = useTranslation()
 
    return (
    
      <Label {...props}>
        <span className="mr-2 font-weight-bold">{t('dataManagement.horosaisonniere.label')}</span>
  
        <Select
          value={options.find((o) => o.value === value)}
          options={options}
          onChange={(option) => {
            if (option) onChange(option.value)
          }}
          width={250}
          fontSize={12}
          bordered
        />
      </Label>
    )
  }